import React from 'react';
import {Button} from 'reactstrap'
import AbstractField from "./AbstractField";
import Icon from "./../icon/FAIcon";
import SearchField from "./SearchField";


/**
 * Hledací field s 2 režimy, první obdobný jako SearchField (komopnenta je pouze obal pro SearchField druhý je pro čtečku čárových kódů, přepíná se tlačítkem s čárovým kódem.
 * Čtečka simuluje klávesnici
 */
class CteckaField extends AbstractField {
    static PropTypes = {
        debounceTime: React.PropTypes.number,
        searchOnChange: React.PropTypes.bool,    // pokud je true, hledá se hned při psaní se spožděním debounceTime, pokud je false, hledá se při stisku hledat nebo enter
    };

    static defaultProps = {
        debounceTime: 250,
        searchOnChange: false
    };

    state = {
        cteckaMode: false
    };

    handleModeSwitch = () => {
        this.setState((prevState) => {
            return {
                cteckaMode: !prevState.cteckaMode
            };
        });
    };

    render() {

        const {cteckaMode} = this.state;
        const {searchOnChange, disabled, ...props} = this.props;

        const cteckaButtonColor = cteckaMode ? "primary" : "secondary";

        return <SearchField
            {...props}
            disabled={disabled}
            searchOnChange={cteckaMode || searchOnChange}
            customButton={<Button color={cteckaButtonColor}
                                  disabled={disabled}
                                  onClick={this.handleModeSwitch}
                                  type="button"><Icon
                icon='barcode'/></Button>}
        />
    }
}

export default CteckaField;
